/*
 * ----------------------------------------
 * SWAP PROTECT WIDGET - STATIC
 * ----------------------------------------
 * 
 * Created by, on behalf of SWAP Commerce: 
 *  SHIFT (https://weareshift.agency)
 *  Jonathan Elliott - Lead Programmer (jonny@weareshift.agency)
 * 
 *  Functions:
 * 
 *  await SWAP.Protect.Product.protectRemove();
 *  await SWAP.Protect.Product.protectReview();
 *  await SWAP.Protect.Product.protectCheck();
 *  await SWAP.Protect.Testing.runAll();
 * 
 */

var clientprofile = `{}`;

// #region Singleton
if(!window.SWAP) {
    /** 
     * Singleton instance for SWAP
     * @namespace SWAP
     */
    window.SWAP = {};
}
// #endregion

// #region Cookie Handling
if(!SWAP.Cookies) {

    /**
     * Single instance for Cookie related functionality. Any functionality which interacts with cookies should be placed here.
     * @namespace SWAP.Cookies
     * @memberof SWAP
     */
    SWAP.Cookies = {};

    /**
     * Used to set a swap cookie.
     * @memberof SWAP.Cookies
     * @param {string} name The name of the cookie to be set.
     * @param {string} value The value of the cookie.
     * @param {string} days The length of time the cookie will be set for.
     * @example
     * // Creates a cookie, named 'test', with a value of 'testvalue', for 1 day.
     * SWAP.Cookies.setCookie('test','testvalue',1);
     */
    SWAP.Cookies.setCookie = function(name, value, days) {
        let d = new Date();
        d.setTime(d.getTime() + (days * 86400000));
        let expires = "expires="+d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    /**
     * Used to retrieve a swap cookie.
     * @memberof SWAP.Cookies
     * @param {string} name The name of the cookie to be retrieved.
     * @example
     * // Gets the cookie named 'test'.
     * let cookie = SWAP.Cookies.getCookie('test');
     */
    SWAP.Cookies.getCookie = function(name) {
        let _name = name + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
            c = c.substring(1);
            }
            if (c.indexOf(_name) == 0) {
            return c.substring(_name.length, c.length);
            }
        }
        return undefined;
    }

    /**
     * Used to invalidate a swap cookie.
     * @memberof SWAP.Cookies
     * @param {string} name The name of the cookie to be invalidated.
     * @example
     * // Unsets the cookie named 'test'.
     * SWAP.Cookies.unsetCookie('test');
     */
    SWAP.Cookies.unsetCookie = function(name) {
        document.cookie = name + "=; Max-Age=0; path=/";
    }

}
// #endregion

// #region Analytics Handling
if(!window.SWAP.Analytics) {

    /**
     * Single instance for Analytics related functionality. Any functionality which interacts with analytics should be placed here.
     * @namespace SWAP.Analytics
     * @memberof SWAP
     */
    window.SWAP.Analytics = {};


    /**
     * Placeholder for firing an analytics event. Does nothing by default - clients are expected to
     * overwrite this function with their own implementation to wire up their analytics tracker of choice.
     * @memberof SWAP.Analytics
     * @param {string} eventName The name of the event.
     * @param {object} eventOptions The settings to be sent to the GA tag.
     * @param {boolean} showDebug If debug settings should be dumped to the console.
     * @example
     * // Fires the event 'swap_protect_test' with two settings passed, and debug disabled.
     * SWAP.Analytics.fireEvent('swap_protect_test', { "test": "value", "test2":"value"}, false);
     */
    window.SWAP.Analytics.fireEvent = function(eventName, eventOptions, showDebug){
    }

}
// #endregion

// #region Currency Singleton
if(!SWAP.Currency) {
    /**
     * Singleton instance for Currency related functionality.
     * @namespace SWAP.Currency
     * @memberof SWAP
     */
    SWAP.Currency = {};
}

if(!SWAP.Currency.formatMoney) {
    /**
     * Used to retrieve a swap cookie.
     * @memberof SWAP.Currency
     * @param {number} ammount The value of the currency.
     * @param {string} symbol The currency formatter, provided by Shopify.
     * @todo 
     * Properly impliment to follow all currency settings from Shopify, pulled from store in liquid using: {{ shop.money_format }}.
     * See: https://stackoverflow.com/questions/68422588/how-to-format-money-on-shopify-using-javascript
     * @example
     * // Fires the event 'swap_protect_test' with two settings passed, and debug disabled.
     * SWAP.Currency.formatMoney('10.00', '${{amount_with_comma_separator}}');
     */
    SWAP.Currency.formatMoney = function(ammount, symbol) {
        /*if (typeof ammount === 'string') { 
            ammount = ammount.replace('.',''); 
        }
        return (symbol + (ammount / 100.0).toFixed(2)).replace('{{amount}}', '').replace('{{amount_with_comma_separator}}', '');*/

        if (typeof ammount === 'string') { 
            ammount = ammount.replace('.',''); 
        }

        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        let formatString = (symbol || '${{amount}}');

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = (typeof precision == 'undefined' ? 2 : precision);
            thousands = (typeof thousands == 'undefined' ? ',' : thousands);
            decimal = (typeof decimal == 'undefined' ? '.' : decimal);

            if (isNaN(number) || number == null) { return 0; }

            number = (number/100.0).toFixed(precision);

            let parts   = number.split('.');
            let integral = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            let fractional   = parts[1] ? (decimal + parts[1]) : '';

            return integral + fractional;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(ammount, 2);
              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(ammount, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(ammount, 2, '.', ',');
              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(ammount, 0, '.', ',');
              break;
          }
        
          return formatString.replace(placeholderRegex, value);
    }
}

// #endregion

// #region Console
if(!SWAP.log) {

    let ranks = { message: 1, warning: 2, error: 3 };
    let consoleMethods = { message: console.log, warning: console.warn, error: console.error };

    /**
     * Used to output debug messages to the console, behaving like console.log/warn/error - any number
     * of arguments of any type can be passed after the level. Messages are filtered against
     * SWAP.log.display, so nothing is shown unless a client raises the display level.
     * @memberof SWAP
     * @param {string} [level=message] The severity of the message. One of 'message', 'warning', 'error'.
     * @param {...*} data The values to output, passed straight through to the underlying console method.
     * @example
     * // Logs a warning, shown when SWAP.log.display is 'warning' or 'error'.
     * SWAP.log('warning', 'Asset not found, falling back to default.', { id: id });
     */
    SWAP.log = function(level, ...data) {
        if(ranks[level] === undefined) {
            data.unshift(level);
            level = 'message';
        }

        let threshold = ranks[SWAP.log.display];

        if(threshold === undefined || ranks[level] > threshold) {
            return;
        }

        consoleMethods[level](...data);
    }

    /**
     * The level of message SWAP.log will output to the console. Each level also includes every level
     * below it - e.g. 'error' also shows 'warning' and 'message', 'warning' also shows 'message'.
     * Defaults to 'none', meaning no debug messages are shown until a client raises it.
     * @memberof SWAP
     * @type {string}
     * @example
     * // Show messages and warnings, but not errors.
     * SWAP.log.display = 'warning';
     */
    SWAP.log.display = 'error';

}
// #endregion


// #region Asset Manager Singleton
if(!SWAP.AssetManager) {
    SWAP.AssetManager = {};

    SWAP.AssetManager.assets = {};
    SWAP.AssetManager.assetOverrides = {};

    SWAP.AssetManager.get = function(id){
        if(this.assetOverrides[id] !== undefined) {
            return this.assetOverrides[id];
        }

        if(this.assets[id] !== undefined) {
            return this.assets[id];
        }

        SWAP.log('warning', 'SWAP.AssetManager: Asset ' + id + ' could not be found.');
        return undefined;
    }

    SWAP.AssetManager.set = function(id, url){
        this.assetOverrides[id] = url;
    }
}

// #endregion

// #region Language Singleton
if(!SWAP.Language) {

    SWAP.Language = {};
    SWAP.Language.languages = {};

    SWAP.Language.get = function(id, locale) {
        if(locale !== undefined) {
            return SWAP.Language.languages[locale][id];
        }
        if(Shopify !== undefined && Shopify.locale !== undefined &&  SWAP.Language.languages[Shopify.locale] !== undefined && SWAP.Language.languages[Shopify.locale][id] !== undefined) {
            return SWAP.Language.languages[Shopify.locale][id];
        }
        return SWAP.Language.languages.default[id];
    }

    SWAP.Language.new = function(locale, data) {
        if(SWAP.Language.languages[locale] !== undefined) {
            return console.warn('SWAP Language: Attempted to add additional language which already exists.', locale);
        }
        SWAP.Language.languages[locale] = data;
    }

    /**
     * Loads languages from a target array into SWAP.Language. If a locale already exists, its content
     * is updated in place - existing ids are overwritten with the new value, new ids are added, and any
     * ids not present in target are left untouched.
     * @memberof SWAP.Language
     * @param {Array} target An array of { locale, content } entries, where content is an array of { id, value } entries.
     * @example
     * await SWAP.Language.load(SWAP.Protect.settings.display.language);
     */
    SWAP.Language.load = async function(target) {
        try {
            for(let language of target) {
                let content = {};

                for(let item of language.content) {
                    content[item.id] = item.value;
                }

                if(SWAP.Language.languages[language.locale] !== undefined) {
                    Object.assign(SWAP.Language.languages[language.locale], content);
                } else {
                    SWAP.Language.new(language.locale, content);
                }
            }

            return true;
        } catch(error) {
            SWAP.log('error', 'Language load error.', error);
            return false;
        }
    }

}
// #endregion

// #region Protect Singleton

if(!SWAP.Protect) {

    /**
     * Singleton instance for SWAP Protect related functionality.
     * @namespace SWAP.Protect
     * @memberof SWAP
     */
    SWAP.Protect = {}

    // #region > Settings

    SWAP.Protect.settings = {};

    /**
     * Parses a JSON string of settings and merges them onto SWAP.Protect.settings.
     * @todo Hard coded default payload for now - replace with a proper function to source this later.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.settings.default = async function() {
        try {
            let json = `{
                            "configuration":{
                                "display": {
                                    "product":{
                                        "slug":"swap-protect"
                                    },
                                    "currency":{
                                        "format":"£{{amount}}"
                                    },
                                    "language":[
                                        {
                                            "locale":"default",
                                            "content":[
                                                { "id":"about_title", "value":"Checkout+" },
                                                { "id":"about_content_default", "value":"Free returns and package protection." },
                                                { "id":"button_viewcart", "value":"View Cart" },
                                                { "id":"button_addcart", "value":"Add to Cart" },
                                                { "id":"button_checkout", "value":"Checkout+ | {{ total_plus_protect }}" },
                                                { "id":"button_addandcheckout", "value":"Checkout+ | {{ total_plus_product_plus_protect }}" },
                                                { "id":"button_checkoutwithout", "value":"Checkout without Checkout+" },
                                                { "id":"subtotal_noprotect", "value":"Subtotal: {{ total_no_protect }}" },
                                                { "id":"subtotail_noprotect_plain", "value":"{{ total_no_protect }}" },
                                                { "id":"protect_value", "value":"{{ protect }}" }
                                            ]
                                        }
                                    ]
                                },
                                "assets":{
                                    "images":[
                                        {
                                            "id":"logo",
                                            "url":"http://cdn.weareshift.agency/protect/logo.svg",
                                            "alt":"SWAP Protect Logo"
                                        }
                                    ]
                                },
                                "restrictions":{
                                    "limit":"500000",
                                    "tags":["swap_noprotect"]
                                }
                            }
                        }`;

            let settings = JSON.parse(json).configuration;

            Object.assign(SWAP.Protect.settings, settings);

            return true;
        } catch(error) {
            SWAP.log('error', "Settings default error.", error);
            return false;
        }
    }

    /**
     * Looks for a `<script data-checkoutplus-data>` block in the DOM and returns its contents as the
     * settings profile to load, so a client can override the baked-in profile without editing this
     * file. Falls back to the given profile string (e.g. the clientprofile var) if no such block is
     * present, or if it's present but empty.
     * @memberof SWAP.Protect
     * @param {string} fallback A properly formatted JSON string of settings to use if no DOM block is found.
     * @returns {string} The JSON string to pass to SWAP.Protect.settings.load.
     */
    SWAP.Protect.settings.resolveClientProfile = function(fallback) {
        let script = document.querySelector('script[data-checkoutplus-data]');

        if(script && script.textContent.trim()) {
            return script.textContent;
        }

        return fallback;
    }

    /**
     * Parses a JSON string of settings and merges it onto SWAP.Protect.settings. Plain objects are
     * merged key by key so unrelated nested settings are preserved; any other value (including arrays)
     * replaces the existing value at that key, and any key not already present is added.
     * @memberof SWAP.Protect
     * @param {string} target A properly formatted JSON string of settings.
     * @example
     * await SWAP.Protect.settings.load(clientprofile);
     */
    SWAP.Protect.settings.load = async function(target) {
        try {
            let data = JSON.parse(target).configuration;

            let stack = [[SWAP.Protect.settings, data]];

            while(stack.length) {
                let [destination, source] = stack.pop();

                for(let key in source) {
                    if(source[key] !== null && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                        if(destination[key] === undefined) {
                            destination[key] = {};
                        }
                        stack.push([destination[key], source[key]]);
                    } else {
                        destination[key] = source[key];
                    }
                }
            }

            return true;
        } catch(error) {
            SWAP.log('error', "Settings load error.", error);
            return false;
        }
    }

    // #endregion

    // #region > Cache

    /**
     * Opts this page instance out of the browser's back/forward cache (bfcache), so a later
     * Back/Forward navigation to it forces a fresh load instead of restoring a stale in-memory
     * snapshot. Intended to be called right after an action that silently changes the cart (e.g.
     * Protect being added or removed by our own code) - a bfcache-restored page has no way of
     * knowing that happened, and would show/act on stale state. Registering an 'unload' listener
     * is what actually disqualifies the page; safe to call more than once - only registers once.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.invalidateCache = function() {
        if(window.__swapProtectCacheInvalidated) {
            return;
        }

        window.addEventListener('unload', function() {});
        window.__swapProtectCacheInvalidated = true;
    }

    // #endregion

    // #region > Product

    SWAP.Protect.Product = {};
    
    /**
     * Fetches the SWAP Protect product from Shopify and caches it on SWAP.Protect.Product.Protect.
     * @memberof SWAP.Protect.Product
     * @param {string} slug The product's handle/slug.
     * @returns {Promise<boolean>} True if the product was fetched successfully, false otherwise.
     * @example
     * await SWAP.Protect.Product.fetch('swap-protect');
     */
    SWAP.Protect.Product.fetch = async function(slug) {

         // Helper refences.
         let settings = SWAP.Protect.settings;

        try {
            let response = await fetch(window.Shopify.routes.root + 'products/' + slug + '.js');       // Fetch the Protect product using Shopify AJAX API.
            SWAP.Protect.Product.Protect = await response.json();           // TODO: Add error checking.
            return true;
        } catch(error) {
            SWAP.log('error', "Product fetch error.", error);
            return false;
        }
    }

    /**
     * Removes any SWAP Protect variants present in the cart by setting their quantity to 0 via
     * Shopify's cart update AJAX API.
     * @memberof SWAP.Protect.Product
     * @param {object} [cart] The Shopify cart object, as returned by cart.js. Fetched via {@link SWAP.Protect.Product.cartGet} if omitted.
     * @returns {Promise<boolean>} True if the cart was updated (or had nothing to remove), false on error.
     * @example
     * await SWAP.Protect.Product.protectRemove(cart);
     */
    SWAP.Protect.Product.protectRemove = async function(cart) {

        if(cart === undefined) {
            cart = await SWAP.Protect.Product.cartGet();
        }

        if(cart === undefined) {
            SWAP.log('error', "Product remove error. Cart was undefined.");
            return false;
        }

        let protectionProduct = SWAP.Protect.Product.Protect;
        let protectionProductVariants = protectionProduct.variants;
        let cartItems = cart.items;
        let updates = {};

        cartItems.forEach(function(cartItem){                       // variants to look for matches.
            protectionProductVariants.forEach(function(variant) {
                if(cartItem.id === variant.id) {
                    updates[cartItem.id] = 0;                       // If found, set the required number to 0 to remove it from the cart.
                }
            });
        });

        if(Object.keys(updates).length === 0) {
            return true;
        }

        try {
            let response = await fetch(window.Shopify.routes.root + 'cart/update.js', {      // Update the cart using the Shopify AJAX API.
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            })

            if(!response.ok) {
                SWAP.log('error', "Product remove error.", await response.json());
                return false;
            }

            SWAP.log('message', "Protect has been removed.");
            SWAP.Protect.invalidateCache();

            return true;
        } catch(error) {
            SWAP.log('error', "Product remove error.", error);
            return false;
        }
    }

    /**
     * Adds the SWAP Protect variant to the cart by setting its quantity to 1 via Shopify's cart
     * update AJAX API.
     * @memberof SWAP.Protect.Product
     * @param {number|string} productid The variant ID of the SWAP Protect product to add.
     * @returns {Promise<boolean>} True if the cart was updated successfully, false on error.
     * @example
     * await SWAP.Protect.Product.protectAdd(variant.id);
     */
    SWAP.Protect.Product.protectAdd = async function(productid) {

        let updates = { [productid]: 1 };

        try {
            let response = await fetch(window.Shopify.routes.root + 'cart/update.js', {  // Send to shopify using the AJAX API.
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
            })

            if(!response.ok) {
                SWAP.log('error', "Product add error.", await response.json());
                return false;
            }

            SWAP.log('message', "Protect has been added.");
            SWAP.Protect.invalidateCache();

            return true;
        } catch(error) {
            SWAP.log('error', "Product add error.", error);
            return false;
        }
    }

    // Was cartCheck
    /**
     * Passes the cart to protectReview to decide whether SWAP Protect should be removed from or
     * adjusted in the cart. If no cart is passed, the current cart is fetched first.
     * @memberof SWAP.Protect.Product
     * @param {object} [cart] The Shopify cart object, as returned by cart.js. If omitted, the
     * current cart is fetched automatically.
     * @returns {Promise<boolean>} True if the check completed successfully, false if the cart
     * could not be fetched or an error occurred.
     * @example
     * await SWAP.Protect.Product.protectCheck();
     * @example
     * await SWAP.Protect.Product.protectCheck(cart);
     */
    SWAP.Protect.Product.protectCheck = async function(cart) {

        let product = SWAP.Protect.Product;
        let ReviewAction = product.ReviewAction;

        try {
            if(cart === undefined) {
                cart = await product.cartGet();
            }

            if(cart === undefined) {
                SWAP.log('error', "Product check error. Cart was undefined.", cart);
                return false;
            }

            let action = await product.protectReview(cart);

            switch(action) {
                case ReviewAction.REMOVE: {

                    SWAP.log('message', "After reviewing the cart, protect is being removed.");

                    return await product.protectRemove(cart);
                }

                case ReviewAction.UPDATE: {

                    SWAP.log('message', "After reviewing the cart, protect is being updated.");

                    let removed = await product.protectRemove(cart);

                    if(!removed) {
                        return false;
                    }

                    let protectionFeeData = product.protectCalculateFee(cart);   // Recalculate to find the variant which should now be added.
                    
                    return await product.protectAdd(protectionFeeData.id);
                }

                case ReviewAction.NONE:
                default: {
                    return true;
                }
            }
        } catch(error) {
            SWAP.log('error', "Product check error.", error);
            return false;
        }
    }


    /**
     * The suggested action SWAP.Protect.Product.protectReview has determined should be taken
     * against the SWAP Protect line item in the cart.
     * @memberof SWAP.Protect.Product
     * @enum {string}
     * @readonly
     */
    SWAP.Protect.Product.ReviewAction = {
        NONE: 'none',
        REMOVE: 'remove',
        UPDATE: 'update'
    };

    // Was cartCheckProcess
    /**
     * Reviews a cart against its calculated SWAP Protect fee (see protectCalculateFee) and decides
     * what, if anything, should be done to the Protect line item in the cart - e.g. removing it if
     * a restricted product is present, the cart's protectable total exceeds the configured limit,
     * or Protect is present with nothing left to protect; or flagging it for an update if the fee
     * currently charged doesn't match what it should be.
     * @memberof SWAP.Protect.Product
     * @param {object} [cart] The Shopify cart object, as returned by cart.js. Fetched via {@link SWAP.Protect.Product.cartGet} if omitted.
     * @returns {Promise<string>} One of the SWAP.Protect.Product.ReviewAction values.
     * @example
     * let action = await SWAP.Protect.Product.protectReview(cart);
     */
    SWAP.Protect.Product.protectReview = async function(cart) {

        let ReviewAction = SWAP.Protect.Product.ReviewAction;

        if(cart === undefined) {
            cart = await SWAP.Protect.Product.cartGet();
        }

        if(cart === undefined) {
            SWAP.log('error', "Product review error. Cart was undefined.");
            return ReviewAction.NONE;
        }

        if(!cart.items || cart.items.length === 0) {
            SWAP.log('message', 'Cart is empty, nothing to review.');
            return ReviewAction.NONE;
        }

        let protectCalculateFee = SWAP.Protect.Product.protectCalculateFee;
        let protectCalculateLimit = SWAP.Protect.Product.protectCalculateLimit;

        let protectionFeeData = protectCalculateFee(cart);    // Calculate what protection fees should be used.

        // Use case: total value of cart + protect is
        SWAP.Protect.State.set(
            'total_plus_protect',
            SWAP.Currency.formatMoney(
                protectionFeeData.protectableTotal + protectionFeeData.fee,
                SWAP.Protect.settings.display.currency.format
            )
        );

        // Use case: showing the value of protect
        SWAP.Protect.State.set(
            'protect',
            SWAP.Currency.formatMoney(
                protectionFeeData.fee,
                SWAP.Protect.settings.display.currency.format
            )
        );

        // Use case: Subtotal
        SWAP.Protect.State.set(
            'total_no_protect',
            SWAP.Currency.formatMoney(
                protectionFeeData.cartTotal - protectionFeeData.feeTotalCurrent,
                SWAP.Protect.settings.display.currency.format
            )
        );

        let protectionAdded = (protectionFeeData.feeTotalCurrent > 0);     // Let the UI know if protection has been added.
        let cartValue = protectionFeeData.protectableTotal; //cart.total_price;  // Get the total price of the cart.
        let protectValue = protectionFeeData.fee;                        // Get what the value of what fee should be added.
        let protectProtectable = protectionFeeData.protectableTotal;

        SWAP.log('message', 'Protection Feed Data:', protectionFeeData);

        // Checks the protect for:
        // - If there is a restricted product in the cart. ReviewAction -> REMOVE
        // - The upper limit of Protect has been reached. ReviewAction -> REMOVE
        // - If there is Protect in the cart, but no products to Protect. ReviewAction -> REMOVE
        // - If there is a missmatch between how much the user is being charged, and how much they should be paying, and they intend to Add. ReviewAction -> UPDATE


        // Restricted products
        let restrictedProducts = SWAP.Protect.settings?.restrictions?.products;
        let restrictedProductsFound = false;

        if(restrictedProducts){
            cart.items.forEach(function(line_item){
                restrictedProducts.forEach(function(restricted){
                    if(line_item.product_id === restricted) {
                        SWAP.log('warning', 'Resticted product found:', line_item.product_id);                        
                        restrictedProductsFound = true;
                    }
                });
            })
        }

        if(restrictedProductsFound) {
            return ReviewAction.REMOVE;
        }

        // Protect Limit
        let protectLimit = protectCalculateLimit();

        if(protectLimit && protectionFeeData.protectableTotal > protectLimit) {
            SWAP.log('warning', 'Protect limit hit:', protectionFeeData.protectableTotal, protectLimit)
            return ReviewAction.REMOVE;
        }

        // Protect in the cart, but no products to Protect.
        if(protectionFeeData.protectableTotal <= 0 && protectionFeeData.feeTotalCurrent > 0) {
            SWAP.log('warning', 'Protect in cart, but no products to protect:', protectionFeeData.protectableTotal, protectionFeeData.feeTotalCurrent)
            return ReviewAction.REMOVE;
        }

        // Missmatch between charged, and how much they should be.        
        if(protectionFeeData.feeTotalCurrent !== protectionFeeData.fee) {
            SWAP.log('warning', 'Protect Fee does not match the current total added:', protectionFeeData.feeTotalCurrent, protectionFeeData.fee)
            return ReviewAction.UPDATE;
        }


        SWAP.log('message', "After reviewing the cart, nothing has changed.");
        return ReviewAction.NONE;

    }



    /**
     * Calculates which SWAP Protect variant/fee applies to a cart, based on the cart's value once
     * any existing Protect fee and ignored/restricted products have been excluded.
     * @memberof SWAP.Protect.Product
     * @param {object} cart The Shopify cart object, as returned by cart.js.
     * @returns {object|undefined} An object describing the calculated fee, or undefined on error.
     * Always includes `cartTotal` (the cart's total price) and `feeTotalCurrent` (the total value
     * of any SWAP Protect variants already in the cart). When `cartTotal` is greater than 0, it
     * also includes:
     * - `id` - The ID of the Protect variant which matches the cart's current value.
     * - `limit` - The lower limit (in the store's active currency) of that variant's bracket.
     * - `fee` - The price of that variant, i.e. the fee that should be charged.
     * - `protectableTotal` - The value of the cart's products, excluding Protect and ignored/restricted products.
     * - `feeCount` - The number of Protect line items found in the cart.
     * @example
     * let fee = SWAP.Protect.Product.protectCalculateFee(cart);
     */
    SWAP.Protect.Product.protectCalculateFee = function(cart) {

        try {
            let protectionProduct = SWAP.Protect.Product.Protect;
            let protectionProductVariants = protectionProduct.variants;
            let calculateValueFromTitle = SWAP.Protect.Product.calculateValueFromTitle;
            let protectRestricted = SWAP.Protect.settings?.restrictions?.ignore;

            let cartTotal = cart.total_price;
            let protectionFees = [];

            protectionProductVariants.forEach(function(variant){                                     // Convert all of the variants into the correct data structure for parsing.
                let limitNoCurrency = calculateValueFromTitle(variant.title);                        // The default lower limit, not including the store's currency rate.

                protectionFees.push({
                    id: variant.id,                                                                  // The ID of the variant.
                    limitNoCurrency: limitNoCurrency,
                    limit: limitNoCurrency * parseFloat(window.Shopify.currency.rate),               // The lower limit of the value, from the Variant Title.
                    fee: variant.price                                                               // The price of the variant, used as the fee.
                })
            });

            // Reduce the protection fee by the value of the Protect product.
            let feeReduction = 0;       // Used to total the value of all the fees.
            let feeCount = 0;           // Used to count the total number of fees.

            protectionFees.forEach(function(protectionFee){     // Loop through all of the protection fees and cart products and identify the total cost and number.
                cart.items.forEach(function(lineitem){
                    if(lineitem.id === protectionFee.id) {
                        feeReduction += protectionFee.fee * lineitem.quantity;
                        feeCount++;
                    }
                });
            });

            // Ignore products which should be excluded
            let cartTotalReduction = 0;

            if(protectRestricted) {
                protectRestricted.forEach(function(ignored){
                    cart.items.forEach(function(lineitem){
                        if(lineitem.id === parseInt(ignored)) {
                            cartTotalReduction += lineitem.price * lineitem.quantity;
                        }
                    });
                });
            }

            let out = {                         // Build the output.
                cartTotal: cartTotal,           // The total of the cart.
                feeTotalCurrent: feeReduction   // The total cost of all the fees added to the cart.
            };

            if(cartTotal > 0) {

                // Loop through all of the costs to find the lowest one which applies.
                let variantId;
                let lowestLimit = Number.MAX_SAFE_INTEGER;
                let protectableTotal = cartTotal - feeReduction - cartTotalReduction;

                for (let i = 0; i < protectionFees.length; i++) {
                    if (
                        protectionFees[i].limit > protectableTotal &&
                        protectionFees[i].limit <= lowestLimit
                    ) {
                        variantId = i;
                        lowestLimit = protectionFees[i].limit;

                    }
                }
                if(variantId === undefined) {
                    variantId = protectionFees.length - 1;
                }

                out = {
                    ...out,                                     // Add the base data
                    id: protectionFees[variantId].id,           // The ID of the variant which represents the current fee.
                    limit: protectionFees[variantId].limit,     // The lower limit of the current fee.
                    fee: protectionFees[variantId].fee,         // The total cost of thefees
                    protectableTotal: protectableTotal,             // The value of the products in the cart, not including Protect.
                    feeCount: feeCount                          // The number of fees in the cart.
                };
            }

            return out;

        } catch(error) {
            SWAP.log('error', "Product calculate fee error.", error);
            return undefined;
        }
    }

    /**
     * Finds which SWAP Protect variant/fee bracket applies to a given protectable total, without
     * requiring a real cart - used to predict a fee for a hypothetical total (e.g. the cart plus
     * a product not yet added). See {@link SWAP.Protect.Product.protectCalculateFee} for the
     * cart-based equivalent, which this mirrors the bracket-selection logic of.
     * @memberof SWAP.Protect.Product
     * @param {number} protectableTotal The value to find a fee bracket for.
     * @returns {{id: number, limit: number, fee: number}} The matching Protect variant's id, the
     * lower limit of its bracket, and its fee.
     * @example
     * let bracket = SWAP.Protect.Product.protectCalculateFeeForTotal(5000);
     */
    SWAP.Protect.Product.protectCalculateFeeForTotal = function(protectableTotal) {

        let protectionProduct = SWAP.Protect.Product.Protect;
        let calculateValueFromTitle = SWAP.Protect.Product.calculateValueFromTitle;

        let protectionFees = protectionProduct.variants.map(function(variant) {
            let limitNoCurrency = calculateValueFromTitle(variant.title);
            return {
                id: variant.id,
                limit: limitNoCurrency * parseFloat(window.Shopify.currency.rate),
                fee: variant.price
            };
        });

        let variantId;
        let lowestLimit = Number.MAX_SAFE_INTEGER;

        for(let i = 0; i < protectionFees.length; i++) {
            if(
                protectionFees[i].limit > protectableTotal &&
                protectionFees[i].limit <= lowestLimit
            ) {
                variantId = i;
                lowestLimit = protectionFees[i].limit;
            }
        }

        if(variantId === undefined) {
            variantId = protectionFees.length - 1;
        }

        return {
            id: protectionFees[variantId].id,
            limit: protectionFees[variantId].limit,
            fee: protectionFees[variantId].fee
        };
    }

    /**
     * Calculates the cart value limit above which SWAP Protect can no longer be applied, converted
     * into the store's active currency using Shopify's conversion rate when available.
     * @memberof SWAP.Protect.Product
     * @returns {number|undefined} The limit in the active currency, or undefined if no limit is set.
     */
    SWAP.Protect.Product.protectCalculateLimit = function() {
        let settings = SWAP.Protect.settings;

        if(settings.restrictions.limit !== undefined && window.Shopify !== undefined) {
            return settings.restrictions.limit * parseFloat(window.Shopify.currency.rate);
        }

        return settings.restrictions.limit;
    }

    /**
     * Parses the numeric value out of a SWAP Protect variant title, e.g. converting a
     * currency-formatted threshold like "£50" into a comparable number. If a text multiplier is
     * configured (settings.display.product.textnames.multiplier), non-digit characters are
     * stripped from the title before multiplying; otherwise the title is parsed as-is.
     * @memberof SWAP.Protect.Product
     * @param {string} title The variant's title, as returned by Shopify (e.g. "£50").
     * @returns {number} The parsed numeric value.
     * @example
     * // Given a multiplier of 100.
     * SWAP.Protect.Product.calculateValueFromTitle('£50'); // => 5000
     */
    SWAP.Protect.Product.calculateValueFromTitle = function(title) {

        let textnames = SWAP.Protect.settings.display?.product?.textnames;
        let multiplier = textnames?.multiplier;

        if(multiplier) {
            return parseInt(title.replace(/[^0-9]/g, '')) * multiplier;
        }

        return parseInt(title);
    }

    /**
     * Fetches the current cart using the Shopify AJAX API.
     * @memberof SWAP.Protect.Product
     * @returns {object|undefined} The cart data, or undefined if the fetch failed.
     */
    SWAP.Protect.Product.cartGet = async function() {
        try {
            let response = await fetch(window.Shopify.routes.root + 'cart.js');   // Fetch the cart using Shopify AJAX API.
            return await response.json();
        } catch(error) {
            SWAP.log('error', "Cart get error.", error);
            return undefined;
        }
    }

    /**
     * Identifies the product page currently being viewed (from the /products/{handle} URL) and
     * fetches its data along with the variant selected via the ?variant= query param, falling
     * back to the product's first variant if none is selected.
     * @memberof SWAP.Protect.Product
     * @returns {Promise<{product: object, variant: object}|undefined>} The product and its
     * selected (or first) variant, or undefined if not on a product page or the fetch failed.
     * @example
     * let { product, variant } = await SWAP.Protect.Product.pageProductGet();
     */
    SWAP.Protect.Product.pageProductGet = async function() {

        let handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];

        if(!handle) {
            SWAP.log('warning', "Page product get error. Not on a product page.");
            return undefined;
        }

        try {
            let response = await fetch(window.Shopify.routes.root + 'products/' + handle + '.js');   // Fetch the product using Shopify AJAX API.
            let product = await response.json();

            let variantId = new URLSearchParams(location.search).get('variant');
            let variant = product.variants.find(function(v) { return v.id == variantId; }) || product.variants[0];

            return { product: product, variant: variant };
        } catch(error) {
            SWAP.log('error', "Page product get error.", error);
            return undefined;
        }
    }

    /**
     * Predicts the cart total if the currently viewed product page's selected variant were added,
     * including what SWAP Protect would then cost, and pushes it to {@link SWAP.Protect.State} as
     * 'total_plus_product_plus_protect'. Does nothing if not on a product page, or if nothing
     * is currently bound to that variable (see {@link SWAP.Protect.Elements.isBound}).
     * @memberof SWAP.Protect.Product
     * @param {object} [cart] The Shopify cart object, as returned by cart.js. Fetched via {@link SWAP.Protect.Product.cartGet} if omitted.
     * @returns {Promise<boolean>} True if the prediction was calculated and set, false otherwise.
     * @example
     * await SWAP.Protect.Product.pagePredictionUpdate();
     */
    SWAP.Protect.Product.pagePredictionUpdate = async function(cart) {

        if(!SWAP.Protect.Elements.isBound('total_plus_product_plus_protect')) {
            return false;
        }

        let page = await SWAP.Protect.Product.pageProductGet();

        if(page === undefined) {
            return false;
        }

        if(cart === undefined) {
            cart = await SWAP.Protect.Product.cartGet();
        }

        if(cart === undefined) {
            SWAP.log('error', "Page prediction error. Cart was undefined.");
            return false;
        }

        // The cart's current protectable value, excluding any Protect fee already in the cart.
        let currentFeeData = SWAP.Protect.Product.protectCalculateFee(cart);
        let cartProtectableTotal = currentFeeData?.protectableTotal || 0;

        let predictedProtectableTotal = cartProtectableTotal + page.variant.price;
        let predictedBracket = SWAP.Protect.Product.protectCalculateFeeForTotal(predictedProtectableTotal);
        let predictedTotal = predictedProtectableTotal + predictedBracket.fee;

        SWAP.Protect.State.set(
            'total_plus_product_plus_protect',
            SWAP.Currency.formatMoney(predictedTotal, SWAP.Protect.settings.display.currency.format)
        );

        return true;
    }



    // #endregion

    // #region > State

    /**
     * Holds live display values (e.g. cart totals) that language templates interpolate via
     * {{ }} placeholders. Values are only ever changed through {@link SWAP.Protect.State.set},
     * which is what triggers any bound elements to re-render.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.State = {};
    SWAP.Protect.State.values = {};

    /**
     * Reads the current value of a state variable.
     * @memberof SWAP.Protect.State
     * @param {string} name The variable name, as referenced in a template's {{ }} placeholder.
     * @returns {*} The current value, or undefined if it has never been set.
     */
    SWAP.Protect.State.get = function(name) {
        return SWAP.Protect.State.values[name];
    }

    /**
     * Updates a state variable and re-renders any elements bound to it.
     * @memberof SWAP.Protect.State
     * @param {string} name The variable name, as referenced in a template's {{ }} placeholder.
     * @param {*} value The new value. Should already be display-ready (e.g. formatted currency).
     */
    SWAP.Protect.State.set = function(name, value) {
        SWAP.Protect.State.values[name] = value;
        SWAP.Protect.Elements.render(name);
    }

    // #endregion

    // #region > Elements

    /**
     * Binds DOM elements to language template keys, so that they can be re-rendered whenever
     * a {@link SWAP.Protect.State} variable they reference changes, without re-fetching the
     * template from {@link SWAP.Language}.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.Elements = {};
    SWAP.Protect.Elements.bindings = new Map();    // varName -> Set of { element, templateKey }

    /**
     * Replaces {{ variable }} placeholders in a template with their current SWAP.Protect.State
     * values. Pure string substitution - does not fetch or re-fetch anything.
     * @memberof SWAP.Protect.Elements
     * @param {string} template The raw template string, as returned by SWAP.Language.get.
     * @returns {string} The interpolated string.
     */
    SWAP.Protect.Elements.interpolate = function(template) {
        return template.replace(/\{\{\s*([\w.]+)\s*\}\}/g, function(match, name) {
            let value = SWAP.Protect.State.get(name);
            return value !== undefined ? value : '';
        });
    }

    /**
     * Removes any bindings for a variable whose element is no longer attached to the DOM (e.g.
     * their block was recreated without re-binding), and returns the remaining live bindings.
     * @memberof SWAP.Protect.Elements
     * @param {string} varName The state variable name.
     * @returns {Set} The live bindings still registered against varName. May be empty.
     */
    SWAP.Protect.Elements.prune = function(varName) {
        let bound = SWAP.Protect.Elements.bindings.get(varName);

        if(!bound) {
            return new Set();
        }

        bound.forEach(function(binding) {
            if(!document.contains(binding.element)) {
                bound.delete(binding);
            }
        });

        return bound;
    }

    /**
     * Re-renders every live element bound to a given state variable.
     * @memberof SWAP.Protect.Elements
     * @param {string} varName The state variable name that changed.
     */
    SWAP.Protect.Elements.render = function(varName) {
        let bound = SWAP.Protect.Elements.prune(varName);

        bound.forEach(function(binding) {
            let template = SWAP.Language.get(binding.templateKey);
            binding.element.innerHTML = SWAP.Protect.Elements.interpolate(template);
        });
    }

    /**
     * Checks whether at least one live element is currently bound to a variable. Useful for
     * skipping expensive calculations (e.g. SWAP.Protect.Product.pagePredictionUpdate) when
     * nothing on the page would actually display the result.
     * @memberof SWAP.Protect.Elements
     * @param {string} varName The state variable name.
     * @returns {boolean} True if at least one live element is bound to varName.
     */
    SWAP.Protect.Elements.isBound = function(varName) {
        return SWAP.Protect.Elements.prune(varName).size > 0;
    }

    /**
     * Registers an element against a language template key. Fetches the template once, works
     * out which SWAP.Protect.State variables it references, and renders it immediately. Call
     * again whenever the element is recreated (e.g. its block is rebuilt) to re-bind it.
     * @memberof SWAP.Protect.Elements
     * @param {HTMLElement} element The element whose innerHTML should track the template.
     * @param {string} templateKey The language string id, as passed to SWAP.Language.get.
     * @example
     * SWAP.Protect.Elements.bind(document.querySelector('#swap-checkout-button'), 'button_checkout');
     */
    SWAP.Protect.Elements.bind = function(element, templateKey) {
        let template = SWAP.Language.get(templateKey);
        let varNames = [...template.matchAll(/\{\{\s*([\w.]+)\s*\}\}/g)].map(function(match) { return match[1]; });

        varNames.forEach(function(name) {
            if(!SWAP.Protect.Elements.bindings.has(name)) {
                SWAP.Protect.Elements.bindings.set(name, new Set());
            }
            SWAP.Protect.Elements.bindings.get(name).add({ element: element, templateKey: templateKey });
        });

        element.innerHTML = SWAP.Protect.Elements.interpolate(template);
    }


    SWAP.Protect.Elements.Build = {};
    SWAP.Protect.Elements.Build.groupContainers = new Map();  // group name -> container element
    SWAP.Protect.Elements.Build.groupObservers = new Map();   // group name -> MutationObserver
    SWAP.Protect.Elements.Build.groupWaiters = new Map();     // group name -> MutationObserver awaiting placement.target

    /**
     * Builds a single element group's container and inserts it into the DOM per its placement.
     * @memberof SWAP.Protect.Elements.Build
     * @param {object} config One entry from SWAP.Protect.settings.elements. If `config.class` is
     * present, it's appended after the container's own `swap-protect-group`/`swap-protect-group--*`
     * classes rather than replacing them. If `config.disabled` is true, the group is skipped
     * entirely (no observer, no container).
     * @returns {HTMLElement|boolean|undefined} The created container; true if the group is
     * disabled and was skipped; or undefined if the placement target wasn't found on the page
     * or the position was unrecognised.
     */
    SWAP.Protect.Elements.Build.group = function(config) {
        if(config.disabled) {
            SWAP.log('message', `Build.group: group "${config.group}" is disabled, skipping.`);
            return true;
        }

        SWAP.Protect.Elements.Build.observe(config);

        let target = document.querySelector(config.placement.target);

        if(!target) {
            if(config.placement['await-element']) {
                SWAP.Protect.Elements.Build.awaitElement(config);
                return undefined;
            }

            SWAP.log('warning', `Build.group: target "${config.placement.target}" not found for group "${config.group}".`);
            return undefined;
        }

        let insertion = {
            'start': 'afterbegin',
            'end': 'beforeend',
            'before': 'beforebegin',
            'after': 'afterend'
        }[config.placement.position.toLowerCase()];

        if(!insertion) {
            SWAP.log('warning', `Build.group: unrecognised position "${config.placement.position}" for group "${config.group}".`);
            return undefined;
        }

        let container = document.createElement('div');
        container.className = `swap-protect-group swap-protect-group--${config.group}`;

        target.insertAdjacentElement(insertion, container);

        SWAP.Protect.Elements.Build.groupContainers.set(config.group, container);

        SWAP.Protect.Elements.Build.elements(config, container);

        return container;
    }

    /**
     * Registered click actions available to elements via their `action` field. Each handler takes
     * no arguments, matching SWAP.Protect.Product.protectCheck/protectRemove's own no-arg usage.
     * @memberof SWAP.Protect.Elements.Build
     */
    SWAP.Protect.Elements.Build.actions = {
        'checkout_with': async function() {
            await SWAP.Protect.Product.protectCheck()
                .then(function() {
                    window.location.href = '/checkout';
                });
        },
        'checkout_without': async function() {
            await SWAP.Protect.Product.protectRemove()
                .then(function() {
                    window.location.href = '/checkout';
                });
        }
    };

    /**
     * Builds a single element from a group's `elements` entry. Honours `type` (used directly as
     * the tag name), `text`: if `text` matches an existing language string id, the element is
     * bound to it via SWAP.Protect.Elements.bind (reactive); otherwise `text` is used verbatim as
     * static content. Also applies `class` and `style` verbatim, if present, `href` (for `a`
     * elements), and wires `action` up to a click handler from SWAP.Protect.Elements.Build.actions
     * (unless `action` is "none"). The `override` field is handled by a later build step.
     * @memberof SWAP.Protect.Elements.Build
     * @param {object} elementConfig One entry from a group's `elements` array.
     * @returns {HTMLElement} The created (but not yet attached) element.
     */
    SWAP.Protect.Elements.Build.element = function(elementConfig) {
        let element = document.createElement(elementConfig.type);

        if(elementConfig.text !== undefined) {
            if(SWAP.Language.get(elementConfig.text) !== undefined) {
                SWAP.Protect.Elements.bind(element, elementConfig.text);
            } else {
                element.textContent = elementConfig.text;
            }
        }

        if(elementConfig.class !== undefined) {
            element.className = elementConfig.class;
        }

        if(elementConfig.style !== undefined) {
            element.style.cssText = elementConfig.style;
        }

        if(elementConfig.type === 'a' && elementConfig.href !== undefined) {
            element.href = elementConfig.href;
        }

        if(elementConfig.action !== undefined && elementConfig.action !== 'none') {
            let action = SWAP.Protect.Elements.Build.actions[elementConfig.action];

            if(!action) {
                SWAP.log('warning', `Build.element: unrecognised action "${elementConfig.action}".`);
            } else {
                element.addEventListener('click', function(event) {
                    event.preventDefault();
                    action();
                });
            }
        }

        return element;
    }

    /**
     * Builds and appends every element in a group's `elements` array into its container. An
     * entry with `disabled: true` is skipped.
     * @memberof SWAP.Protect.Elements.Build
     * @param {object} config One entry from SWAP.Protect.settings.elements.
     * @param {HTMLElement} container The group's container, as created by Build.group.
     */
    SWAP.Protect.Elements.Build.elements = function(config, container) {
        (config.elements || []).forEach(function(elementConfig) {
            if(elementConfig.disabled) {
                SWAP.log('message', `Build.elements: element (type "${elementConfig.type}") is disabled for group "${config.group}", skipping.`);
                return;
            }

            container.appendChild(SWAP.Protect.Elements.Build.element(elementConfig));
        });
    }

    /**
     * Watches config.observe for changes and rebuilds the group's container if it's ever found
     * to be missing from the DOM (e.g. the theme replaced the surrounding markup wholesale).
     * @memberof SWAP.Protect.Elements.Build
     * @param {object} config One entry from SWAP.Protect.settings.elements. No-ops if it has no
     * `observe` field.
     */
    SWAP.Protect.Elements.Build.observe = function(config) {
        if(!config.observe) {
            return;
        }

        let existing = SWAP.Protect.Elements.Build.groupObservers.get(config.group);
        if(existing) {
            existing.disconnect();
        }

        let target = document.querySelector(config.observe);

        if(!target || !target.parentNode) {
            SWAP.log('warning', `Build.observe: observe target "${config.observe}" not found for group "${config.group}".`);
            return;
        }

        let observer = new MutationObserver(function() {
            let container = SWAP.Protect.Elements.Build.groupContainers.get(config.group);
            let intact = container && document.contains(container) && container.classList.contains(`swap-protect-group--${config.group}`);

            if(!intact) {
                SWAP.log('message', `Build.observe: observe target "${config.observe}" changed and container for group "${config.group}" is missing or was overwritten, rebuilding.`, container);
                SWAP.Protect.Elements.Build.group(config);
            }
        });

        observer.observe(target.parentNode, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true
        });

        SWAP.log('message', `Build.observe: now observing "${config.observe}" for group "${config.group}".`, target.parentNode);

        SWAP.Protect.Elements.Build.groupObservers.set(config.group, observer);
    }

    /**
     * Watches the DOM until config.placement.target exists, then builds the group. Used when
     * config.placement['await-element'] is true and the target isn't present on the page yet
     * (e.g. it's rendered lazily/asynchronously after load). No-ops if a wait for this group is
     * already in progress.
     * @memberof SWAP.Protect.Elements.Build
     * @param {object} config One entry from SWAP.Protect.settings.elements.
     */
    SWAP.Protect.Elements.Build.awaitElement = function(config) {
        if(SWAP.Protect.Elements.Build.groupWaiters.has(config.group)) {
            return;
        }

        let observer = new MutationObserver(function() {
            if(!document.querySelector(config.placement.target)) {
                return;
            }

            observer.disconnect();
            SWAP.Protect.Elements.Build.groupWaiters.delete(config.group);
            SWAP.Protect.Elements.Build.group(config);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        SWAP.Protect.Elements.Build.groupWaiters.set(config.group, observer);
    }

    /**
     * Builds every element group defined in SWAP.Protect.settings.elements.
     * @memberof SWAP.Protect.Elements.Build
     * @returns {Map} SWAP.Protect.Elements.Build.groupContainers, for convenience.
     */
    SWAP.Protect.Elements.Build.groups = function() {
        SWAP.Protect.settings.elements.forEach(function(config) {
            SWAP.Protect.Elements.Build.group(config);
        });

        return SWAP.Protect.Elements.Build.groupContainers;
    }

    /**
     * Builds all UI elements defined in SWAP.Protect.settings.elements. Placeholder entry point -
     * currently only builds groups, but will grow to call the rest of the element/action builders
     * as they're added, so init only ever needs this one call.
     * @memberof SWAP.Protect.Elements.Build
     * @returns {Promise<boolean>} True if the build completed without error, false otherwise.
     */
    SWAP.Protect.Elements.Build.initialize = async function() {
        try {
            SWAP.Protect.Elements.Build.groups();

            return true;
        } catch(error) {
            SWAP.log('error', 'Element build error.', error);
            return false;
        }
    }

    // #endregion

    // #region > Events

    /**
     * Hooks into the storefront theme's pub/sub events (Dawn's PUB_SUB_EVENTS/subscribe) to keep
     * SWAP Protect's UI in sync with the cart and the customer's variant selection.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.Events = {};

    /**
     * Subscribes to the theme's cart-update and variant-change pub/sub events, so Protect's
     * derived UI state stays current without polling. Logs a warning and returns false instead
     * of throwing if the theme doesn't expose subscribe/PUB_SUB_EVENTS.
     * @memberof SWAP.Protect.Events
     * @returns {boolean} True if the hooks were registered, false if pub/sub wasn't available.
     */
    SWAP.Protect.Events.initialize = function() {

        if(typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
            SWAP.log('warning', 'Protect events error. Theme pub/sub (subscribe/PUB_SUB_EVENTS) not available.');
            return false;
        }

        subscribe(PUB_SUB_EVENTS.cartUpdate, async function() {
            await SWAP.Protect.Product.protectReview();
            await SWAP.Protect.Product.pagePredictionUpdate();
        });

        subscribe(PUB_SUB_EVENTS.variantChange, async function() {
            await SWAP.Protect.Product.pagePredictionUpdate();
        });

        return true;
    }

    // #endregion

    // #region > Patches

    /**
     * Container for individual patches that adjust existing functionality elsewhere in the system
     * to work around behaviour that can't otherwise be fixed from here. Each patch is kept in its
     * own namespace with its own `initialize`, so patches stay independent of one another and
     * could be split into their own files later without needing to be untangled first.
     *
     * Available patches:
     * - {@link SWAP.Protect.Patches.Fetch} - the shared window.fetch middleware pipeline the
     *   patches below register into, instead of each wrapping fetch independently.
     * - {@link SWAP.Protect.Patches.PatchCart} - folds Protect's removal into the Shopify Ajax
     *   Cart API's update/change calls when a pending change would otherwise orphan it.
     * - {@link SWAP.Protect.Patches.RemoveAutomatically} - removes Protect from the cart on every
     *   page load, as a safety net for it being left behind outside of a live cart interaction.
     * - {@link SWAP.Protect.Patches.CartWatcher} - detects any cart change by watching the cart
     *   endpoints directly, and makes the same calls SWAP.Protect.Events' cartUpdate subscriber
     *   would, as a fallback for themes without reliable pub/sub.
     * @memberof SWAP.Protect
     */
    SWAP.Protect.Patches = {};

    /**
     * Shared window.fetch middleware pipeline. Installed once via {@link SWAP.Protect.Patches.Fetch.patch},
     * this lets multiple patches intercept the Shopify Ajax Cart API without each independently
     * re-wrapping window.fetch (which would make their relative ordering depend on patch-install
     * order). Handlers registered via {@link SWAP.Protect.Patches.Fetch.use} run in an onion
     * model - a handler that doesn't care about a request just returns next() untouched; one that
     * does calls `let response = await next();` to let the rest of the chain (and, ultimately,
     * the real fetch) resolve first, then inspects/transforms that response. Handlers registered
     * via {@link SWAP.Protect.Patches.Fetch.useLast} are always composed as the outermost layer,
     * regardless of registration order - so a useLast() handler always observes the fully
     * resolved result of every use() handler, guaranteed structurally rather than by convention.
     * @memberof SWAP.Protect.Patches
     */
    SWAP.Protect.Patches.Fetch = {};

    // Handlers registered via use()/useLast() - see the pipeline doc comment above for why they're kept separate.
    SWAP.Protect.Patches.Fetch.middleware = [];
    SWAP.Protect.Patches.Fetch.after = [];

    /**
     * Registers a normal-priority fetch middleware handler.
     * @memberof SWAP.Protect.Patches.Fetch
     * @param {string} name Identifies the handler in the middleware list (for debugging).
     * @param {function(object, function): Promise<Response>} handler (context, next) => Promise<Response>.
     */
    SWAP.Protect.Patches.Fetch.use = function(name, handler) {
        SWAP.Protect.Patches.Fetch.middleware.push({ name: name, handler: handler });
    }

    /**
     * Registers a fetch middleware handler that always runs outermost - i.e. always observes the
     * fully resolved response of every use()-registered handler, regardless of registration order.
     * @memberof SWAP.Protect.Patches.Fetch
     * @param {string} name Identifies the handler in the middleware list (for debugging).
     * @param {function(object, function): Promise<Response>} handler (context, next) => Promise<Response>.
     */
    SWAP.Protect.Patches.Fetch.useLast = function(name, handler) {
        SWAP.Protect.Patches.Fetch.after.push({ name: name, handler: handler });
    }

    /**
     * Composes the registered handlers into a single chain and runs it for one fetch call.
     * @memberof SWAP.Protect.Patches.Fetch
     * @param {RequestInfo} input
     * @param {RequestInit} [init]
     * @returns {Promise<Response>}
     */
    SWAP.Protect.Patches.Fetch.dispatch = function(input, init) {
        let chain = SWAP.Protect.Patches.Fetch.after.map(function(m) { return m.handler; })
            .concat(SWAP.Protect.Patches.Fetch.middleware.map(function(m) { return m.handler; }));

        let index = -1;

        function next() {
            index++;

            if(index < chain.length) {
                return chain[index]({ input: input, init: init }, next);
            }

            return SWAP.Protect.Patches.Fetch.originalFetch(input, init);
        }

        return next();
    }

    /**
     * Installs the window.fetch monkey-patch used by every fetch middleware handler. Safe to call
     * more than once - only ever patches fetch a single time.
     * @memberof SWAP.Protect.Patches.Fetch
     */
    SWAP.Protect.Patches.Fetch.patch = function() {
        if(window.fetch.__swapProtectFetchPatched) {
            return;
        }

        SWAP.Protect.Patches.Fetch.originalFetch = window.fetch.bind(window);
        window.fetch = SWAP.Protect.Patches.Fetch.dispatch;
        window.fetch.__swapProtectFetchPatched = true;
    }

    /**
     * Monkey-patches window.fetch to intercept the Shopify Ajax Cart API's update/change calls:
     * lets the real request go through untouched (Shopify's own server is the only thing that can
     * safely resolve which line/variant a request like change.js's `line` addresses - themes vary
     * in how they number cart rows, e.g. Protect's own row may be excluded from a theme's visible
     * numbering, so guessing this ourselves is unsafe), then inspects the *actual* resulting cart
     * from the real response. If that leaves SWAP Protect as the only item remaining, a follow-up
     * removal call is fired and awaited before the wrapped fetch resolves, so the caller only ever
     * observes one, final, fully-reconciled response - never a stale/out-of-sync one. Enabled via
     * configuration.display.product['patch-cart'].
     * @memberof SWAP.Protect.Patches
     */
    SWAP.Protect.Patches.PatchCart = {};

    // Shopify's storefront JS doesn't consistently call these with the ".js" suffix (e.g. some
    // themes fetch '/cart/change' rather than '/cart/change.js') - matched optionally so both
    // forms are caught, with a lookahead so "/cart/updated" or similar can't false-match.
    SWAP.Protect.Patches.PatchCart.CART_UPDATE_PATTERN = /\/cart\/update(\.js)?(?=[/?#]|$)/;
    SWAP.Protect.Patches.PatchCart.CART_CHANGE_PATTERN = /\/cart\/change(\.js)?(?=[/?#]|$)/;

    /**
     * Whether a fetch URL targets one of the cart endpoints this patch cares about.
     * @memberof SWAP.Protect.Patches.PatchCart
     * @param {string} url
     * @returns {boolean}
     */
    SWAP.Protect.Patches.PatchCart.isCartMutation = function(url) {
        return typeof url === 'string' && (
            SWAP.Protect.Patches.PatchCart.CART_UPDATE_PATTERN.test(url) ||
            SWAP.Protect.Patches.PatchCart.CART_CHANGE_PATTERN.test(url)
        );
    }

    /**
     * Inspects the real response to a cart/update.js or cart/change.js request and, if it leaves
     * SWAP Protect as the only item remaining with a quantity above 0, fires and awaits a
     * follow-up cart/update.js call to zero it out, returning that follow-up's response in place
     * of the original - so the caller only ever sees one, final, fully-reconciled response. This
     * never re-derives which line/variant the original request addressed (that's already been
     * authoritatively resolved by Shopify's own server by the time this runs) - it only looks at
     * what the cart actually now contains. Fails open on any error - always returns a usable
     * Response, falling back to the original on any error or if the follow-up itself fails.
     * @memberof SWAP.Protect.Patches.PatchCart
     * @param {Response} response The real response to the original request.
     * @param {RequestInit} init The original request's init, used to carry over sections/sections_url.
     * @returns {Promise<Response>}
     */
    SWAP.Protect.Patches.PatchCart.reconcile = async function(response, init) {
        try {
            if(!response.ok) {
                SWAP.log('message', 'Patches.PatchCart: request failed, nothing to reconcile.');
                return response;
            }

            let cart = await response.clone().json();
            let protectVariantIds = (SWAP.Protect.Product.Protect?.variants || []).map(function(v) { return v.id; });

            if(protectVariantIds.length === 0) {
                SWAP.log('message', 'Patches.PatchCart: no Protect variants known yet, nothing to reconcile.');
                return response;
            }

            let feeData = SWAP.Protect.Product.protectCalculateFee(cart);

            SWAP.log('message', 'Patches.PatchCart: resulting cart after request.', feeData);

            // Same condition protectReview already uses to decide Protect should be removed
            // (protect.js "Protect in the cart, but no products to Protect") - evaluated here
            // against the real post-request cart rather than a guess at what it would be.
            if(!feeData || feeData.feeTotalCurrent <= 0 || feeData.protectableTotal > 0) {
                SWAP.log('message', 'Patches.PatchCart: Protect is not orphaned, nothing to reconcile.', {
                    feeTotalCurrent: feeData?.feeTotalCurrent,
                    protectableTotal: feeData?.protectableTotal
                });
                return response;
            }

            let protectRemaining = cart.items
                .filter(function(item) { return protectVariantIds.includes(item.id) && item.quantity > 0; })
                .map(function(item) { return item.id; });

            if(protectRemaining.length === 0) {
                SWAP.log('message', 'Patches.PatchCart: no Protect variant left in the cart, nothing to reconcile.');
                return response;
            }

            let updates = {};
            protectRemaining.forEach(function(id) {
                updates[id] = 0;
            });

            let requestBody = (init && typeof init.body === 'string') ? JSON.parse(init.body) : {};
            let followUpBody = { updates: updates };

            if(requestBody.sections !== undefined) {
                followUpBody.sections = requestBody.sections;
            }
            if(requestBody.sections_url !== undefined) {
                followUpBody.sections_url = requestBody.sections_url;
            }

            SWAP.log('message', 'Patches.PatchCart: Protect orphaned by that request, firing follow-up removal.', followUpBody);

            let followUp = await SWAP.Protect.Patches.Fetch.originalFetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(followUpBody)
            });

            if(!followUp.ok) {
                SWAP.log('error', 'Patches.PatchCart: follow-up removal failed, returning the original response.', await followUp.json());
                return response;
            }

            SWAP.log('message', 'Patches.PatchCart: follow-up removal succeeded.');
            SWAP.Protect.invalidateCache();

            return followUp;
        } catch(error) {
            SWAP.log('error', 'Patches.PatchCart reconcile error.', error);
            return response;
        }
    }

    /**
     * Fetch middleware handler that intercepts cart update/change calls, registered into
     * {@link SWAP.Protect.Patches.Fetch} by {@link SWAP.Protect.Patches.PatchCart.initialize}.
     * @memberof SWAP.Protect.Patches.PatchCart
     * @param {object} context {input, init} - see {@link SWAP.Protect.Patches.Fetch.dispatch}.
     * @param {function} next Continues the fetch middleware chain.
     * @returns {Promise<Response>}
     */
    SWAP.Protect.Patches.PatchCart.middleware = async function(context, next) {
        let url = (typeof context.input === 'string') ? context.input : context.input?.url;

        if(!SWAP.Protect.Patches.PatchCart.isCartMutation(url)) {
            return await next();
        }

        SWAP.log('message', 'Patches.PatchCart: intercepted cart request.', url, context.init);

        let response = await next();

        return await SWAP.Protect.Patches.PatchCart.reconcile(response, context.init);
    }

    /**
     * Enables this patch if configured to via configuration.display.product['patch-cart'].
     * @memberof SWAP.Protect.Patches.PatchCart
     * @returns {boolean} True, unless registering itself throws - never blocks init.
     */
    SWAP.Protect.Patches.PatchCart.initialize = function() {
        try {
            if(SWAP.Protect.settings.display.product['patch-cart']) {
                SWAP.Protect.Patches.Fetch.use('PatchCart', SWAP.Protect.Patches.PatchCart.middleware);
                SWAP.log('message', 'Patches.PatchCart activated.');
            }

            return true;
        } catch(error) {
            SWAP.log('error', 'Patches.PatchCart initialize error.', error);
            return false;
        }
    }

    /**
     * Removes SWAP Protect from the cart automatically on every page load, if configured to via
     * configuration.display.product['remove-automatically'] - e.g. to guard against it being left
     * in the cart after everything else was removed some other way, without needing to refresh
     * the cart to reconcile it.
     * @memberof SWAP.Protect.Patches
     */
    SWAP.Protect.Patches.RemoveAutomatically = {};

    /**
     * Removes SWAP Protect from the cart. Thin wrapper around
     * {@link SWAP.Protect.Product.protectRemove}, kept separate from `initialize` so this patch's
     * one moving part (checking the setting) stays distinct from the removal itself.
     * @memberof SWAP.Protect.Patches.RemoveAutomatically
     * @returns {Promise<boolean>} True if the cart was updated (or had nothing to remove), false on error.
     */
    SWAP.Protect.Patches.RemoveAutomatically.remove = async function() {
        return await SWAP.Protect.Product.protectRemove();
    }

    /**
     * Enables this patch if configured to via configuration.display.product['remove-automatically'].
     * @memberof SWAP.Protect.Patches.RemoveAutomatically
     * @returns {Promise<boolean>} True, unless the removal itself fails.
     */
    SWAP.Protect.Patches.RemoveAutomatically.initialize = async function() {
        try {
            if(SWAP.Protect.settings.display.product['remove-automatically']) {
                SWAP.log('message', 'Patches.RemoveAutomatically activated.');
                return await SWAP.Protect.Patches.RemoveAutomatically.remove();
            }

            return true;
        } catch(error) {
            SWAP.log('error', 'Patches.RemoveAutomatically initialize error.', error);
            return false;
        }
    }

    /**
     * Detects any change to the cart by watching the Shopify Ajax Cart API's add/update/change/
     * clear endpoints directly, and - only when the cart actually changed - makes the same calls
     * SWAP.Protect.Events' cartUpdate subscriber makes (protectReview + pagePredictionUpdate), as
     * a fallback for themes that don't expose working pub/sub, or custom code that calls the cart
     * endpoints directly without going through it. Does not attempt to fire the theme's actual
     * pub/sub events itself, only the calls that would otherwise happen in response to them.
     * Registered via {@link SWAP.Protect.Patches.Fetch.useLast}, so it always observes the cart
     * after every other fetch middleware (e.g. {@link SWAP.Protect.Patches.PatchCart}) has
     * already run - structurally guaranteed, not just by initialize() ordering. Enabled via
     * configuration.display.product['patch-cartwatcher'].
     * @memberof SWAP.Protect.Patches
     */
    SWAP.Protect.Patches.CartWatcher = {};

    SWAP.Protect.Patches.CartWatcher.CART_ADD_PATTERN = /\/cart\/add(\.js)?(?=[/?#]|$)/;
    SWAP.Protect.Patches.CartWatcher.CART_UPDATE_PATTERN = /\/cart\/update(\.js)?(?=[/?#]|$)/;
    SWAP.Protect.Patches.CartWatcher.CART_CHANGE_PATTERN = /\/cart\/change(\.js)?(?=[/?#]|$)/;
    SWAP.Protect.Patches.CartWatcher.CART_CLEAR_PATTERN = /\/cart\/clear(\.js)?(?=[/?#]|$)/;

    /**
     * Whether a fetch URL targets one of the cart endpoints this patch cares about.
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @param {string} url
     * @returns {boolean}
     */
    SWAP.Protect.Patches.CartWatcher.isCartMutation = function(url) {
        return typeof url === 'string' && (
            SWAP.Protect.Patches.CartWatcher.CART_ADD_PATTERN.test(url) ||
            SWAP.Protect.Patches.CartWatcher.CART_UPDATE_PATTERN.test(url) ||
            SWAP.Protect.Patches.CartWatcher.CART_CHANGE_PATTERN.test(url) ||
            SWAP.Protect.Patches.CartWatcher.CART_CLEAR_PATTERN.test(url)
        );
    }

    /**
     * Whether a fetch URL is a cart/add.js call - its response is the added line item(s), not
     * the full cart, unlike update/change/clear which all respond with the full cart object.
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @param {string} url
     * @returns {boolean}
     */
    SWAP.Protect.Patches.CartWatcher.isCartAdd = function(url) {
        return typeof url === 'string' && SWAP.Protect.Patches.CartWatcher.CART_ADD_PATTERN.test(url);
    }

    /**
     * Builds a small comparable signature of a cart, used to detect whether a mutation actually
     * changed anything. Item quantities are sorted by id so a change in line order alone doesn't
     * look like a real change.
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @param {object} [cart] The Shopify cart object, as returned by cart.js.
     * @returns {string|undefined} The signature, or undefined if cart is falsy.
     */
    SWAP.Protect.Patches.CartWatcher.signature = function(cart) {
        if(!cart) {
            return undefined;
        }

        let items = (cart.items || [])
            .map(function(item) { return item.id + ':' + item.quantity; })
            .sort()
            .join(',');

        return cart.item_count + '|' + cart.total_price + '|' + items;
    }

    // The last-seen cart signature, kept local to this patch rather than a shared cache, so it
    // can be lifted into its own file later without untangling other patches' state.
    SWAP.Protect.Patches.CartWatcher.lastSignature = undefined;

    /**
     * Resolves the cart's post-mutation state, compares it against the last-known signature, and
     * - only if it actually changed - makes the same calls SWAP.Protect.Events' cartUpdate
     * subscriber makes. Fails open on any error - never throws.
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @param {string} url The request URL, used to decide whether the full cart needs re-fetching.
     * @param {Response} response The (already fully reconciled) response to the mutation.
     */
    SWAP.Protect.Patches.CartWatcher.reconcile = async function(url, response) {
        try {
            if(!response.ok) {
                SWAP.log('message', 'Patches.CartWatcher: request failed, nothing to reconcile.');
                return;
            }

            let after = SWAP.Protect.Patches.CartWatcher.isCartAdd(url)
                ? await SWAP.Protect.Product.cartGet()
                : await response.clone().json();

            let afterSignature = SWAP.Protect.Patches.CartWatcher.signature(after);

            if(afterSignature === SWAP.Protect.Patches.CartWatcher.lastSignature) {
                SWAP.log('message', 'Patches.CartWatcher: no change detected, nothing to do.');
                return;
            }

            SWAP.log('message', 'Patches.CartWatcher: cart changed, emulating cartUpdate.', after);

            SWAP.Protect.Patches.CartWatcher.lastSignature = afterSignature;

            await SWAP.Protect.Product.protectReview(after);
            await SWAP.Protect.Product.pagePredictionUpdate(after);
        } catch(error) {
            SWAP.log('error', 'Patches.CartWatcher reconcile error.', error);
        }
    }

    /**
     * Fetch middleware handler that watches cart mutations, registered into
     * {@link SWAP.Protect.Patches.Fetch} (via useLast) by {@link SWAP.Protect.Patches.CartWatcher.initialize}.
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @param {object} context {input, init} - see {@link SWAP.Protect.Patches.Fetch.dispatch}.
     * @param {function} next Continues the fetch middleware chain.
     * @returns {Promise<Response>}
     */
    SWAP.Protect.Patches.CartWatcher.middleware = async function(context, next) {
        let url = (typeof context.input === 'string') ? context.input : context.input?.url;

        if(!SWAP.Protect.Patches.CartWatcher.isCartMutation(url)) {
            return await next();
        }

        let response = await next();

        await SWAP.Protect.Patches.CartWatcher.reconcile(url, response);

        return response;
    }

    /**
     * Enables this patch if configured to via configuration.display.product['patch-cartwatcher'].
     * @memberof SWAP.Protect.Patches.CartWatcher
     * @returns {Promise<boolean>} True, unless activation itself throws - never blocks init.
     */
    SWAP.Protect.Patches.CartWatcher.initialize = async function() {
        try {
            if(SWAP.Protect.settings.display.product['patch-cartwatcher']) {
                SWAP.Protect.Patches.CartWatcher.lastSignature = SWAP.Protect.Patches.CartWatcher.signature(await SWAP.Protect.Product.cartGet());
                SWAP.Protect.Patches.Fetch.useLast('CartWatcher', SWAP.Protect.Patches.CartWatcher.middleware);
                SWAP.log('message', 'Patches.CartWatcher activated.');
            }

            return true;
        } catch(error) {
            SWAP.log('error', 'Patches.CartWatcher initialize error.', error);
            return false;
        }
    }

    /**
     * Initializes every registered patch. Each patch's own initialize() is responsible for
     * deciding whether it should actually activate (typically gated by its own setting).
     * @memberof SWAP.Protect.Patches
     * @returns {Promise<boolean>} True if every patch initialized without error, false otherwise.
     */
    SWAP.Protect.Patches.initialize = async function() {
        SWAP.Protect.Patches.Fetch.patch();   // Installs the shared fetch pipeline once, before any patch below registers into it.

        let results = [
            SWAP.Protect.Patches.PatchCart.initialize(),
            await SWAP.Protect.Patches.RemoveAutomatically.initialize(),
            await SWAP.Protect.Patches.CartWatcher.initialize()
        ];

        return results.every(Boolean);
    }

    // #endregion

    // #region > Lifecycle

    SWAP.Protect.initialize = async function() {

        let protect = SWAP.Protect;
        let settings = protect.settings;

        // Load the testing suite (dev-only; harmless no-op if the file's missing/removed in prod).
        await new Promise(function(resolve) {
            let script = document.createElement('script');
            script.src = new URL('protect.testing.js', document.currentScript.src).href;
            script.onload = resolve;
            script.onerror = resolve;   // Don't block init if the testing file isn't present.
            document.head.appendChild(script);
        });
        
        // Load the default settings and languages.
        let initDefaults = [
            await settings.default(),                                   // Load the default settings.
            await SWAP.Language.load(settings.display.language)         // Load languages from the default data.
        ];

        // Load the client profile and languages, then fetch the protect product - done here,
        // after the client profile is loaded, so a client override of display.product.slug is
        // actually respected instead of always fetching the default slug.
        let initClient = [
            await settings.load(settings.resolveClientProfile(clientprofile)),   // Load the client profile, preferring a DOM override if present.
            await SWAP.Language.load(settings.display.language),         // Load languages from the client profile.
            await protect.Product.fetch(settings.display.product.slug)   // Load the protect product.
        ];

        // Initialize every registered patch (e.g. patching the cart Ajax API, removing Protect
        // automatically on load) - each patch decides for itself whether it's configured to activate.
        let initPatches = [
            await SWAP.Protect.Patches.initialize()
        ];

        let initBuild = [
            await SWAP.Protect.Elements.Build.initialize(),              // Builds the UI elements.
        ];

        SWAP.Protect.Events.initialize();   // Hook into theme pub/sub events to keep the UI in sync. TODO: Make a set of optional things to be inited as not all stores will have these events.

        let results = [...initDefaults, ...initClient, ...initPatches, ...initBuild];

        if(!results.every(Boolean)) {
            SWAP.log('error', 'SWAP Protect failed to initialize.', results);
            return false;
        }

        return true;
    }

    SWAP.Protect.unload = async function() {
        SWAP.log('error', "%c 📦 SWAP Protect Unloaded.", "display: inline-block; background: #ff3232; padding: 1rem; font-family:sans-serif; text-transform: uppercase; width:100%;");
    }

    // #endregion

}


(async function(){

    let protect = SWAP.Protect;

    SWAP.log("message", "%c 📦 Swap Protect Launching.", "display: inline-block; background: #fbf9f1; padding: 1rem; font-family:sans-serif; text-transform: uppercase; width:100%;");

    let initialized = await protect.initialize();

    if(initialized) {

        await protect.Product.protectReview();
        await protect.Product.pagePredictionUpdate();

        SWAP.log("message", "%c 📦 SWAP Protect launched successfully.", "display: inline-block; background: #d4edda; padding: 1rem; font-family:sans-serif; text-transform: uppercase; width:100%;");
    } else {
        SWAP.Protect.unload();
    }

})();

// #endregion